import React, {useEffect, useState} from 'react';
import './CharacterEditor.css'
import { useCharacter } from "./CharacterProvider";
import CharacterSelector from "./CharacterSelector";
import CharacterForm from "./CharacterForm";
import CharacterSkills from "./CharacterSkills";
import { printCharacterSheet } from "./printCharacterSheet";
import * as api from "./utils-api";


const CharacterEditor = ({token}) => {
    const {currentCharacter} = useCharacter();
    const [races, setRaces] = useState([]);
    const [skillsets, setSkillsets] = useState([]);
    const [availableSkills, setAvailableSkills] = useState([]);

    api.setToken(token);

    useEffect(() => {
        (async function () {
            setRaces(await api.fetchRaces());
            setSkillsets(await api.fetchSkillsets());
        })();
    }, [token]);

    useEffect(() => {
        async function fetchSkillsForCharacter() {
            if (currentCharacter?.characterId) {
                const fetchedSkills = await api.fetchSkills({ characterId: currentCharacter.characterId });
                setAvailableSkills(fetchedSkills);
            }
        }
        fetchSkillsForCharacter();
        // eslint-disable-next-line
    }, [currentCharacter?.characterId, token]);


    return (
        <div className="character-select-container">
            <h1 className="landing-title">Character Manager</h1>
            <CharacterSelector token={token} />

            {currentCharacter && (
                <>
                    <div className="print-button-row">
                        <button
                            className="btn"
                            onClick={() => {
                                printCharacterSheet({
                                    character: currentCharacter,
                                    races,
                                    skillsets,
                                    availableSkills,
                                });
                            }}
                        >
                            🖨️ Print Character Sheet
                        </button>
                    </div>

                    <CharacterForm
                        races={races}
                        skillsets={skillsets}
                        availableSkills={availableSkills}
                    />
                    <CharacterSkills
                        token={token}
                        availableSkills={availableSkills}
                    />
                </>
            )}

        </div>
    );
}

export default CharacterEditor;
